import { render, staticRenderFns } from "./personal.vue?vue&type=template&id=07aa5398&scoped=true&"
import script from "./personal.vue?vue&type=script&lang=js&"
export * from "./personal.vue?vue&type=script&lang=js&"
import style0 from "./personal.vue?vue&type=style&index=0&id=07aa5398&lang=scss&scoped=true&"
import style1 from "./personal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aa5398",
  null
  
)

component.options.__file = "personal.vue"
export default component.exports